import { RoleStatus } from "./types"

// 角色状态标签映射
export const RoleStatusLabels: Record<RoleStatus, string> = {
  [RoleStatus.ACTIVE]: "激活",
  [RoleStatus.INACTIVE]: "未激活",
}

// 角色状态颜色映射
export const RoleStatusColors: Record<RoleStatus, string> = {
  [RoleStatus.ACTIVE]: "green",
  [RoleStatus.INACTIVE]: "red",
}

// 角色名称验证规则常量
export const ROLE_NAME_VALIDATION = {
  /** 角色名称最小长度 */
  MIN_LENGTH: 2,
  /** 角色名称最大长度 */
  MAX_LENGTH: 50,
  /** 必填错误消息 */
  REQUIRED_MESSAGE: "请输入角色名称",
  /** 最小长度错误消息 */
  MIN_MESSAGE: "角色名称至少2个字符",
  /** 最大长度错误消息 */
  MAX_MESSAGE: "角色名称不能超过50个字符",
} as const

// 角色代码验证规则常量
export const ROLE_CODE_VALIDATION = {
  /** 角色代码最小长度 */
  MIN_LENGTH: 2,
  /** 角色代码最大长度 */
  MAX_LENGTH: 50,
  /** 角色代码正则表达式（只允许英文、数字、下划线） */
  PATTERN: /^[A-Z_][A-Z0-9_]*$/,
  /** 必填错误消息 */
  REQUIRED_MESSAGE: "请输入角色代码",
  /** 最小长度错误消息 */
  MIN_MESSAGE: "角色代码至少2个字符",
  /** 最大长度错误消息 */
  MAX_MESSAGE: "角色代码不能超过50个字符",
  /** 格式错误消息 */
  PATTERN_MESSAGE: "角色代码只能包含大写英文、数字和下划线，且必须以大写字母或下划线开头",
} as const

// 角色描述验证规则常量
export const ROLE_NOTE_VALIDATION = {
  /** 角色备注最大长度 */
  MAX_LENGTH: 200,
  /** 最大长度错误消息 */
  MAX_MESSAGE: "角色备注不能超过200个字符",
} as const
